import { EquipSlot } from "@/domains/inventory/constants/equipSlot";

export default function isEquipmentSlot(value: string): value is EquipSlot {
  return Object.values(EquipSlot).includes(value as EquipSlot);
}
